module.exports = __webpack_public_path__ + "files/7c7fb75b907b151c73ce3ff770b365ca.svg";